module.exports = __webpack_public_path__ + "static/media/yearn.8f8c7849.svg";